import React from 'react';
import { IconButton } from '@mui/material';
import { ZoomIn, ZoomOut } from '@mui/icons-material';
import { useFamilyTree } from './FamilyTreeProvider';

const ZoomControls = () => {
  const { zoom, updateZoom } = useFamilyTree();

  const handleZoomIn = () => {
    const newZoom = Math.min(5, zoom * 1.2);
    updateZoom(newZoom);
  };

  const handleZoomOut = () => {
    const newZoom = Math.max(0.1, zoom / 1.2);
    updateZoom(newZoom);
  };

  return (
    <div
      style={{
        position: 'absolute',
        bottom: '16px',
        right: '16px',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        zIndex: 1000,
      }}
    >
      <IconButton
        onClick={handleZoomIn}
        sx={{
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          color: 'rgba(255, 255, 255, 0.9)',
          border: '1px solid rgba(255, 255, 255, 0.18)',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            border: '1px solid rgba(255, 255, 255, 0.3)',
          },
        }}
        aria-label="Zoom in"
      >
        <ZoomIn />
      </IconButton>
      <IconButton
        onClick={handleZoomOut}
        sx={{
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          color: 'rgba(255, 255, 255, 0.9)',
          border: '1px solid rgba(255, 255, 255, 0.18)',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            border: '1px solid rgba(255, 255, 255, 0.3)',
          },
        }}
        aria-label="Zoom out"
      >
        <ZoomOut />
      </IconButton>
    </div>
  );
};

export default ZoomControls;
